import { setBreadcrumbs, useLoadingOverlay } from '@/hooks';
import { trans } from '@/i18n';
import { ROUTE_PATH } from '@/routes';
import { PlanService } from '@/services/plan';
import { IPlanForm } from '@/types';
import { showSuccess } from '@/utils';
import { Box, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import PlanForm from './components/Form';
import './styles/create-plan.scss';

function CreatePlanPage() {
  const navigate = useNavigate();
  const sv = new PlanService();
  const { toggleLoading } = useLoadingOverlay();

  // Breadcrumbs
  setBreadcrumbs(ROUTE_PATH.PLAN, [
    { name: trans('menu.plan'), path: ROUTE_PATH.PLAN },
    { name: trans('menu.createPlan') },
  ]);

  const handleSubmit = async (data: IPlanForm) => {
    try {
      toggleLoading(true);
      await sv.storeData(data);
      showSuccess(trans('plan.createSuccess'));
      navigate(ROUTE_PATH.PLAN);
    } catch (error) {
      console.log(error);
    } finally {
      toggleLoading(false);
    }
   
  };

  return (
    <Box width="full" alignContent="center" className='plan-create-page'>
      <Text className="page-title">{trans('plan.create')}</Text>
      <Text className="page-subtitle" color="gray.400">
        {trans('plan.createSubtitle')}
      </Text>
      <Box className="box-create-content" width="1127px">
        <Text fontSize="18px" fontWeight="bold" color="gray.500" mb={4}>
          {trans('plan.form')}
        </Text>
        <PlanForm mode="create" onSubmit={handleSubmit} loadingUpdate={false} />
      </Box>
    </Box>
  );
}

export default CreatePlanPage;
